/*
 * Copyright (c) 2019 EDF
 */
define('org/forgerock/commons/ui/common/util/detectiOS',[], function() {
    var exports = function () {
      // iOS detection
        var detectiOS = false;
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            detectiOS = (/OS (.*) like Mac OS/.exec(navigator.userAgent))[1].replace("_",".").split("_")[0];
        }
        return detectiOS ;
    };

    return exports;
});


